import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import * as CMP from '@edreamsodigeo/frontend-cmp-client';
import { getGeoLocations } from '../../redux/geoLocations/actions';
import { initPreviousSearches } from '../../redux/previousSearch/actions';

import { URLUtils } from '../../utils';
import { CurrentAccommodationSearchService } from '../../services';

export const SearchManager = ({ children }) => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state);

    useEffect(() => {
        const urlParams = URLUtils.getHomeHashParams();
        if (!isEmpty(urlParams)) {
            dispatch(getGeoLocations(urlParams));
        }

        if (CMP.isAllowed('localStorage', 'previous-search-data')) {
            dispatch(initPreviousSearches());
        } else {
            CMP.onChangeUserCMP(() => {
                dispatch(initPreviousSearches());
            });
        }
    }, [dispatch]);

    useEffect(() => {
        if (state.currentSearch) {
            CurrentAccommodationSearchService.updateReduxStoreOrInitializeSessionStorage(state, dispatch);
        }
    }, []);

    return children;
};

SearchManager.propTypes = {
    children: PropTypes.node.isRequired,
};
